import styled, { css, keyframes } from 'styled-components';
import { media } from './Layout';

interface styleType {
  imageSrc?: string;
}

export const GridLayoutContent = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1070px;
  padding-left: 16px;
  padding-right: 16px;
`;

export const GridLayoutTitle = styled.div`
  margin-top: 60px;

  font-family: 'NotoKrM';

  /* Mobile Device */
  font-size: 15px;
  margin-bottom: 10px;

  ${media.desktop`
    margin-bottom: 18px;
    font-size: 20px;
  `};
`;

export const ImageContainCard = styled.a`
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  box-shadow: 0 3px 0 0 rgba(0, 0, 0, 0.08);
  background-color: white;
  overflow: hidden;
  color: #000000;
  :focus {
    color: #000000;
  }
  :hover {
    color: #000000;
  }
`;

export const ImageNonCard = styled.a`
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  box-shadow: 0 3px 0 0 rgba(0, 0, 0, 0.08);
  background-color: white;
  color: #000000;
  :focus {
    color: #000000;
  }
  :hover {
    color: #000000;
  }
`;

export const CardImage = styled.div`
  width: 100%;

  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;

  /* Mobile Device */
  height: 140px;

  ${media.desktop`  
    height: 200px;
  `};

  ${(props: styleType) => {
    if (props.imageSrc) {
      return css`
        background-image: url(${props.imageSrc});
      `;
    }
    return css``;
  }}
`;

export const Textbox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;

  /* Mobile Device */
  padding: 12px 16px 12px 16px;

  ${media.desktop`
  padding: 20px;
`};
`;
export const CardTitle = styled.div`
  display: flex;
  font-family: 'NotoKrM';
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  /* Mobile Device */
  font-size: 15px;

  ${media.desktop`
    margin-bottom: 18px;
    font-size: 20px;
  `};
`;

export const CardSource = styled.div`
  display: flex;
  font-family: 'NotoKrR';
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;
